import React, { useEffect, useState } from "react";
import { CloseOutlined, CheckOutlined, ExpandAltOutlined, DeleteOutlined, PlusSquareFilled, DeleteRowOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Space, Form, Select, Input, Grid, type FormInstance, Button } from 'antd';
import type { AlignType } from 'rc-table/lib/interface';

import { errorMessage, successMessage } from "../../../messages/messages";

import type { IComponente, IInstituto, ISelectList, ITipo, ITipoComponenteResgatePortabilidade } from "../../../components/Interfaces";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { numberOnly } from "../../../utils/maskFunctions";
import TextArea from "antd/es/input/TextArea";
import { hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  institutos: IInstituto[];
  setInstitutos: React.Dispatch<React.SetStateAction<IInstituto[]>>;
  caracteristica: number;
  resgateParcial: boolean;
  listTiposInstitutos: ITipo[];
  listTiposComponentes: ITipoComponenteResgatePortabilidade[];
  listUnidadesMedida: ISelectList[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const { useBreakpoint } = Grid;

const Instituto = ({ form, institutos, setInstitutos, caracteristica, resgateParcial, listTiposInstitutos, listTiposComponentes, listUnidadesMedida, manter }: IProps) => {
  // const [form] = Form.useForm();
  const screens = useBreakpoint();

  const [estadoModal, setEstadoModal] = useState(-1); // 1 : Modal em modo inserção (neste form, nunca será 1) / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [institutoSelecionado, setInstitutoSelecionado] = useState<IInstituto>()

  const [unidadeMedidaCarencia, setUnidadeMedidaCarencia] = useState(0);
  // const [dadosInstitutoValidados, setDadosInstitutoValidados] = useState(false);

  const [exibirModalInstituto, setExibirModalInstituto] = useState(false);

  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");

  const [componentes, setComponentes] = useState<IComponente[]>([]);
  const [tipoModal, setTipoModal] = useState(0); // 1 RESGATE INTEGRAL / 2: RESGATE PARCIAL / 3: PORTABILIDADE / 4: DEMAIS (AUTOPATROCINIO E BPD)
  const [listTiposComponentesPeloTipoInstituto, setListTiposComponentesPeloTipoInstituto] = useState<ITipoComponenteResgatePortabilidade[]>([]);

  const [carregaDemaisInstitutosAutoPatrocinio, setCarregaDemaisInstitutosAutoPatrocinio] = useState(false);
  const [carregaDemaisInstitutosBPD, setCarregaDemaisInstitutosBPD] = useState(false);
  const [carregaDemaisInstitutosPortabilidade, setCarregaDemaisInstitutosPortabilidade] = useState(false);
  const [carregaInstitutoResgate, setCarregaInstitutoResgate] = useState(false);

  useEffect(() => {
    if (institutos.length === 0) {
      const carregaDadosInstitutos = () => {
        // carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "AUTOPATROCÍNIO")?.id || "");
        // carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "BENEFÍCIO PROPORCIONAL DIFERIDO")?.id || "");
        // carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "PORTABILIDADE")?.id || "");
        // carregaPadraoInstitutoResgate(false);
        setCarregaDemaisInstitutosAutoPatrocinio(true);
        setCarregaDemaisInstitutosBPD(true);
        setCarregaDemaisInstitutosPortabilidade(true);
        setCarregaInstitutoResgate(true);
      }
      carregaDadosInstitutos();
    }
  }, []);

  // useEffect(() => {
  //   if (dadosInstitutoValidados) {
  //     setDadosInstituto();
  //   }
  // }, [dadosInstitutoValidados])

  useEffect(() => {
    if (carregaDemaisInstitutosAutoPatrocinio) {
      carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "AUTOPATROCÍNIO")?.id || "");
    }
  }, [carregaDemaisInstitutosAutoPatrocinio])

  useEffect(() => {
    if (carregaDemaisInstitutosBPD) {
      carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "BENEFÍCIO PROPORCIONAL DIFERIDO")?.id || "");
    }
  }, [carregaDemaisInstitutosBPD])

  useEffect(() => {
    if (carregaDemaisInstitutosPortabilidade) {
      carregaPadraoDemaisInstitutos(listTiposInstitutos.find((i) => i.nome === "PORTABILIDADE")?.id || "");
    }
  }, [carregaDemaisInstitutosPortabilidade])

  useEffect(() => {
    if (carregaInstitutoResgate) {
      carregaPadraoInstitutoResgate(false);
    }
  }, [carregaInstitutoResgate])

  useEffect(() => {
    if (institutoSelecionado) {
      let nmTpInstituto = listTiposInstitutos.find((f) => f.id === institutoSelecionado.tipoInstitutoId)?.nome;
      if (nmTpInstituto === "RESGATE" && !institutoSelecionado.resgateParcial) {
        setListTiposComponentesPeloTipoInstituto(listTiposComponentes.filter(f => f.resgateIntegral &&
          (caracteristica === 2 && f.planoInstituido) ||
          (caracteristica === 1 && f.planoPatrocinado)));
        setTipoModal(1);
      } else if ((nmTpInstituto === "RESGATE" && institutoSelecionado.resgateParcial)) {
        setListTiposComponentesPeloTipoInstituto(listTiposComponentes.filter(f => f.resgateParcial ||
          (caracteristica === 2 && f.planoInstituido) ||
          (caracteristica === 1 && f.planoPatrocinado)));
        setTipoModal(2);
      } else if (nmTpInstituto === "PORTABILIDADE") {
        setListTiposComponentesPeloTipoInstituto(listTiposComponentes.filter(f => f.portabilidade &&
          ((caracteristica === 2 && f.planoInstituido) ||
            (caracteristica === 1 && f.planoPatrocinado))));
        setTipoModal(3);
      } else {
        setTipoModal(4);
      }
      controleDaGrid("editar");
    }
  }, [institutoSelecionado]);

  // useEffect(() => {
  //   //console.log(institutos);
  // }, [institutos]);

  useEffect(() => {
    if (resgateParcial) {
      // Se ainda não tiver o RESGATE PARCIAL, INSERI.
      if (institutos.findIndex(f => f.resgateParcial) === -1) {
        carregaPadraoInstitutoResgate(true);
      }
    } else {
      setInstitutos(institutos.filter(f => !f.resgateParcial))
    }
  }, [resgateParcial]);

  useEffect(() => {
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal])

  const carregaPadraoInstitutoResgate = (resgParcial: boolean) => {
    const localListComponetesResgateObrigatorio =
      !resgParcial ?
        listTiposComponentes.filter(
          (t) => t.resgateIntegralObrigatorio
        )
        :
        listTiposComponentes.filter(
          (t) => t.resgateParcialObrigatorio
        )

    const localComponentesResgateObrigatorios: IComponente[] = localListComponetesResgateObrigatorio.map((item) => ({
      id: "",
      tipoComponenteResgatePortabilidadeId: item.id,
      inicioId: "",
      fimId: "",
      marcadoParaExclusao: false,
    }));

    const localTipoInstitutoId = listTiposInstitutos.find((i) => i.nome === "RESGATE")?.id || "";

    setInstitutos(prev => {
      const next = [
        ...prev,
        {
          id: "",
          fundamentacaoRegulamentar: "",
          detalhamento: "",
          resgateParcial: resgParcial,
          validado: 0,
          carencia: 0,
          unidadeMedidaCarencia: 0,
          tipoInstitutoId: localTipoInstitutoId,
          inicioId: "",
          fimId: "",
          componentes: localComponentesResgateObrigatorios.map((e: IComponente) => {
            return {
              ...e
            };
          }),
          emEdicao: false,
          tableKey: resgParcial ? "resgateParcial" : localTipoInstitutoId,
          tipoInstitutoNome: listTiposInstitutos.find(l => l.id === localTipoInstitutoId)?.nome
        }
      ]
      //      //console.log("Inside updater", next); // correct value
      return next;

    })
  };


  const carregaPadraoDemaisInstitutos = (tpInstId: string) => {
    setInstitutos(prev => {
      const next = [
        ...prev,
        {
          id: "",
          fundamentacaoRegulamentar: "",
          detalhamento: "",
          resgateParcial: false,
          validado: 0,
          tipoInstitutoId: tpInstId,
          inicioId: "",
          fimId: "",
          componentes: [],
          emEdicao: false,
          tableKey: tpInstId,
          tipoInstitutoNome: listTiposInstitutos.find(l => l.id === tpInstId)?.nome
        }
      ]
      //console.log("Inside updater", next); // correct value
      return next;
    })
  };

  const validaAlterarDetalharInstituto = (inst: IInstituto, estado: number) => {
    form
      .validateFields()
      .then(() => {
        setFieldsDetalharEditar(inst);
        setEstadoModal(estado); // SET O MODO DETALHAR
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });
  }

  const controleDaGrid = (botao: string) => {
    if (botao === "cancelar" || botao === "incluir" || botao === "ok" || botao === "Alterar") {
      setExibirModalInstituto(false);
      setExibirElementoAcaoAlteracao("inline");
    } else {
      setExibirModalInstituto(true);
      setExibirElementoAcaoAlteracao("none");
    }

    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validaInstituto = () => {

    form
      .validateFields([
        "nmTpInstituto",
        "fundamentacaoRegulamentar",
        "carencia",
        "nmUnidadeMedida",
        "nmTpComponente",
        "detalhamento"
      ])
      .then(() => {
        if (!validarCampos()) {
          return
        }
        controleDaGrid("ok");
        // setDadosInstitutoValidados(true);
        setDadosInstituto();

        successMessage("Instituto Atualizado");
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido ou não validado");
      });

  };

  function validarCampos(): boolean {

    if (institutoSelecionado?.tipoInstitutoId === "") {
      errorMessage("O tipo de Instituto não foi identificado.");
      return false;
    }

    if (componentes.length === 0 && (tipoModal < 4)) {
      errorMessage("Inclua um Componente");
      return false;
    }

    if (componentes.length > 0 && (tipoModal === 4)) {
      errorMessage("Componentes não são permitidos para este tipo de instituto");
      return false;
    }

    return true;
  }

  function setDadosInstituto() {
    const currentForm = form.getFieldsValue();

    setInstitutos(pre => {
      return pre.map(inst => {
        if (inst.emEdicao) {
          return ({
            id: institutoSelecionado?.id || "",
            fundamentacaoRegulamentar: currentForm.fundamentacaoRegulamentar.toUpperCase(),
            detalhamento: currentForm.detalhamento.toUpperCase(),
            resgateParcial: inst.resgateParcial,

            validado: 0,
            carencia: caracteristica === 2 ? currentForm.carencia : undefined,
            unidadeMedidaCarencia: caracteristica === 2 ? unidadeMedidaCarencia : undefined,

            tipoInstitutoId: institutoSelecionado?.tipoInstitutoId || "",
            inicioId: institutoSelecionado?.inicioId || "",
            fimId: "",
            componentes: componentes.map((e: IComponente) => {
              return {
                ...e
              };
            }),
            emEdicao: false,
            tableKey: inst.tableKey,
            tipoInstitutoNome: listTiposInstitutos.find(l => l.id === inst.tipoInstitutoId)?.nome
          })
        } else {
          return inst
        }
      })
    });

    limpaDados();
    setEstadoModal(-1); // SETA O MODAL PARA DETALHE (MODO PADRÃO).
  }


  const columnsComponentes = [
    {
      key: "1",
      title: "Componente",
      dataIndex: "",
      render: (comp: IComponente) => (
        <div>
          {listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.nome}
        </div>
      ),
    },
    {
      key: "9",
      width: 30,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (comp: IComponente) => (
        <>
          <Space>
            {/* RESGATE INTEGRAL: tipoModal === 1 */}
            <div style={{ display: tipoModal === 1 ? "inline" : "none" }}>
              <div style={{ display: manter !== 2 ? "inline" : exibirElementoAcaoAlteracao }}>
                <DeleteRowOutlined
                  title="Excluir registro ainda não gravado na base."
                  style={{ color: "red", display: (comp.id === "" && !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateIntegralObrigatorio) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                  onClick={() => {
                    setComponentes(componentes.filter((c) => c !== comp));
                  }}
                />
              </div>

              <div style={{ display: (comp?.id && comp?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}>
                <>
                  <PlusSquareFilled
                    title="Desmarcar para exclução"
                    style={{
                      color: "blue", display: (comp.marcadoParaExclusao &&
                        !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateIntegralObrigatorio)
                        ? "inline" : "none"
                    }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(c => {
                          if (c.id === comp.id) {
                            return comp;
                          } else {
                            return c;
                          }
                        });
                      });

                    }}
                  />
                </>

                <>
                  <DeleteOutlined
                    title="Marcar para exclução/inativação"
                    style={{
                      color: "red", display: (!comp.marcadoParaExclusao &&
                        !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateIntegralObrigatorio)
                        ? "inline" : "none"
                    }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(t => {
                          if (t.id === comp.id) {
                            return comp;
                          } else {
                            return t;
                          }
                        });
                      });

                    }}
                  />
                </>
              </div>

            </div>

            {/* RESGATE PARCIAL: tipoModal === 2 */}
            <div style={{ display: tipoModal === 2 ? "inline" : "none" }}>

              <div style={{ display: manter !== 2 ? "inline" : exibirElementoAcaoAlteracao }}>
                <DeleteRowOutlined
                  title="Excluir registro ainda não gravado na base."
                  style={{ 
                    color: "red", display: (comp.id === "" && 
                      !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateParcialObrigatorio) 
                      ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                  onClick={() => {
                    setComponentes(componentes.filter((c) => c !== comp));
                  }}
                />
              </div>
              {/* <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
                <FontAwesomeIcon icon={faTrash}
                  title="Excluir"
                  style={{
                    color: "red", display: (comp.id === "" &&
                      !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateParcialObrigatorio)
                      ? "inline" : "none"
                  }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                  onClick={() => {
                    setComponentes(componentes.filter((c) => c !== comp));
                  }}
                />
              </div> */}

              <div style={{ display: (comp?.id && comp?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}>
                <>
                  <PlusSquareFilled
                    title="Desmarcar para exclução"
                    style={{
                      color: "blue", display: (comp.marcadoParaExclusao &&
                        !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateParcialObrigatorio)
                        ? "inline" : "none"
                    }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(c => {
                          if (c.id === comp.id) {
                            return comp;
                          } else {
                            return c;
                          }
                        });
                      });

                    }}
                  />
                </>

                <>
                  <DeleteOutlined
                    title="Marcar para exclução/inativação"
                    style={{
                      color: "red", display: (!comp.marcadoParaExclusao &&
                        !listTiposComponentes.find((l) => l.id === comp.tipoComponenteResgatePortabilidadeId)?.resgateParcialObrigatorio)
                        ? "inline" : "none"
                    }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(t => {
                          if (t.id === comp.id) {
                            return comp;
                          } else {
                            return t;
                          }
                        });
                      });

                    }}
                  />
                </>
              </div>
            </div>

            {/* PORTABILIDADE: tipoModal === 3 */}
            <div style={{ display: tipoModal === 3 ? "inline" : "none" }}>

              <div style={{ display: manter !== 2 ? "inline" : exibirElementoAcaoAlteracao }}>
                <DeleteRowOutlined
                  title="Excluir registro ainda não gravado na base."
                  style={{ color: "red", display: comp.id === "" ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                  onClick={() => {
                    setComponentes(componentes.filter((c) => c !== comp));
                  }}
                />
              </div>

              <div style={{ display: (comp?.id && comp?.id !== "") && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}>
                <>
                  <PlusSquareFilled
                    title="Desmarcar para exclução"
                    style={{ color: "blue", display: (comp.marcadoParaExclusao) ? "inline" : "none" }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(c => {
                          if (c.id === comp.id) {
                            return comp;
                          } else {
                            return c;
                          }
                        });
                      });

                    }}
                  />
                </>

                <>
                  <DeleteOutlined
                    title="Marcar para exclução/inativação"
                    style={{ color: "red", display: (!comp.marcadoParaExclusao) ? "inline" : "none" }}
                    onClick={() => {
                      comp.marcadoParaExclusao = !comp.marcadoParaExclusao; // INVERTE 
                      setComponentes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                        return pre.map(t => {
                          if (t.id === comp.id) {
                            return comp;
                          } else {
                            return t;
                          }
                        });
                      });

                    }}
                  />
                </>
              </div>
            </div>
          </Space>
        </>
      ),
    },

  ];

  const columnsInstituto = [
    {
      key: "1",
      title: "Instituto",
      dataIndex: "tipoInstitutoNome",
    },
    {
      key: "2",
      title: "",
      dataIndex: "",
      render: (inst: IInstituto) => (
        <div>
          {inst?.resgateParcial ? "Parcial" : ""}
        </div>
      ),
    },
    {
      key: "9",
      width: 20,

      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (inst: IInstituto) => (
        <>
          <Space>
            <div style={{ display: manter === 2 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  validaAlterarDetalharInstituto(inst, 2);
                }}
              />
            </div>

            <div style={{ display: manter === 1 && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : exibirElementoAcaoAlteracao }}>
              <FontAwesomeIcon icon={faPenToSquare}
                title="Editar"
                style={{ color: "blue" }}
                onClick={() => {
                  validaAlterarDetalharInstituto(inst, 3);
                  institutos.forEach(i => {
                    if (i === inst) {
                      i.emEdicao = true;
                    } else {
                      i.emEdicao = false;
                    }
                  })
                  inst.emEdicao = true;
                }}
              />

            </div>
          </Space>
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setEstadoModal(-1); // COLOCA O MODAL EM ESTADO DE NEUTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    limpaDados();
  };


  const setFieldsDetalharEditar = (inst: IInstituto) => {

    setComponentes(inst.componentes);
    form.setFieldsValue({
      nmTpInstituto: listTiposInstitutos.find((l) => l.id === inst.tipoInstitutoId)?.nome,
      fundamentacaoRegulamentar: inst.fundamentacaoRegulamentar,
      carencia: inst.carencia,
      nmUnidadeMedida: listUnidadesMedida.find(l => l.value === inst.unidadeMedidaCarencia)?.label,
      detalhamento: inst.detalhamento
    })
    setInstitutoSelecionado(inst);
    setComponentes(inst.componentes);
    setUnidadeMedidaCarencia(inst.unidadeMedidaCarencia || 0);
  }

  const handlerComponente = async (tpInst: any) => {
    if (!componentes.find((f) => f.tipoComponenteResgatePortabilidadeId === tpInst.key)) {
      setComponentes([
        ...componentes,
        {
          id: "",
          tipoComponenteResgatePortabilidadeId: tpInst.key,
          inicioId: institutoSelecionado?.id || "",
          fimId: "",
          marcadoParaExclusao: false,
        },
      ]);
    }
  }

  const handleUnidadeMedida = async (undMed: any) => {
    form.setFieldsValue({
      nmUnidadeMedida: undMed.label,
    });
    setUnidadeMedidaCarencia(undMed.value);
  };

  function limpaDados() {
    setComponentes([]);
    setInstitutoSelecionado(undefined);
    setUnidadeMedidaCarencia(0);
    form.resetFields([
      "nmTpInstituto",
      "fundamentacaoRegulamentar",
      "carencia",
      "nmUnidadeMedida",
      "nmTpComponente",
      "detalhamento"
    ]);

  }

  return (
    <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >
      <>
        <Modal title="Alterar Instituto" open={exibirModalInstituto}
          style={{ top: 20 }}
          width={screens.xl ? 1000 : 600}
          destroyOnHidden={true}
          closable={false}
          // cancelText="Cancelar"
          // cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          // onOk={() => {
          //   validaInstituto();
          // }}
          // okText="Ok"
          // okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validaInstituto}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >

          <Row>
            <Col xs={24} md={12} xl={12}>
              <Form.Item label="Tipo"
                labelAlign="left"
                labelCol={{ span: 20 }}
                name="nmTpInstituto"
                colon={false}
              >
                <Input
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={12}>
              <Form.Item label="Fundamentação Regulamentar"
                name="fundamentacaoRegulamentar"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Preencha o campo Fundamentação Regulamentar",
                  },
                ]}
              >
                <Input
                  disabled={manter === 2 ? true : false}
                  placeholder="Fundamentação Regulamentar"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row hidden={tipoModal !== 1}>
            <Col xs={24} md={12} xl={12}>
              <Form.Item label="Carência"
                name="carencia"
                colon={false}
                rules={[
                  {
                    required: caracteristica === 2 && tipoModal === 1, // INSTITUIDOR E RESGATE INTEGRAL
                    message: "Informe a Carência",
                  },
                ]}
              >
                <Input
                  disabled={manter === 2 ? true : caracteristica === 1} // DISABILITA SE CARACTERISTICA FOR PATROCINADOR
                  placeholder="Carência"
                  onChange={(e) =>
                    form.setFieldsValue({
                      carencia: numberOnly(e.target.value),
                    })
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={8} xl={8}>
              <Form.Item
                label="Unidade de Medida"
                name="nmUnidadeMedida"
                rules={[
                  {
                    required: caracteristica === 2 && tipoModal === 1, // INSTITUIDOR E RESGATE INTEGRAL
                    message: "Selecione a Unidade de Medida",
                  },
                ]}
              >
                <Select
                  disabled={manter === 2 ? true : caracteristica === 1} // DISABILITA SE CARACTERISTICA FOR PATROCINADOR
                  showSearch filterOption optionFilterProp='children'
                  placeholder="Unidade de Medida"
                  options={listUnidadesMedida}
                  onChange={(_, index) => {
                    handleUnidadeMedida(index);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row hidden={tipoModal === 4}>
            <Col xs={24} md={24} xl={24}>
              <Form.Item label="Componente do Instituto"
                labelAlign="left"
                labelCol={{ span: 20 }}
                name="nmTpComponente"
                colon={false}
              >
                <Select
                  disabled={manter === 2 ? true : false}
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Componentes'
                  onChange={(_, index) => {
                    handlerComponente(index);
                  }}
                >
                  {listTiposComponentesPeloTipoInstituto.map((e: ITipoComponenteResgatePortabilidade) => (
                    <Select.Option key={e.id} value={e.nome}>
                      {e.nome}
                    </Select.Option>
                  ))}
                </Select>

              </Form.Item>
            </Col>
          </Row>

          <Row style={{ display: componentes && componentes.length > 0 ? "inline" : "none" }}>
            <Col
              xs={24}
              sm={24}
            >
              <Table
                size="small" rowKey="tipoComponenteResgatPortabilidadeId" columns={columnsComponentes} dataSource={componentes} pagination={false} />
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <Form.Item label="Detalhamento"
                name="detalhamento"
                colon={false}
              >
                <TextArea
                  disabled={manter === 2 ? true : false}
                  placeholder="Detalhamento"
                />
              </Form.Item>
            </Col>
          </Row>
        </Modal>

      </>

      <Row>
        <Col xs={12} md={12} xl={12}>
          <Table
            size="small" rowKey="tableKey"
            columns={columnsInstituto} dataSource={institutos} pagination={false} />
        </Col>
      </Row>
    </Form>
  )
};

export default Instituto;
